"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.literalist = exports.catalog = void 0;
function catalog(catalog, factory) {
    if (Array.isArray(catalog)) {
        return catalog.reduce((result, current, index) => {
            return Object.assign(Object.assign({}, result), { [current]: factory != undefined ? factory(current, index) : current });
        }, {});
    }
    else {
        return catalog;
    }
}
exports.catalog = catalog;
/**
 * Alias for compatibility
 * @deprecated - use `catalog`
 */
exports.literalist = catalog;
